var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.852539 7.81627V20.523C0.852539 21.3656 1.18949 22.1736 1.78928 22.7693C2.38906 23.365 3.20255 23.6997 4.05077 23.6997H26.4384C27.2866 23.6997 28.1001 23.365 28.6999 22.7693C29.2997 22.1736 29.6366 21.3656 29.6366 20.523V7.81627M0.852539 7.81627V4.63958C0.852539 3.79707 1.18949 2.98907 1.78928 2.39332C2.38906 1.79758 3.20255 1.46289 4.05077 1.46289H26.4384C27.2866 1.46289 28.1001 1.79758 28.6999 2.39332C29.2997 2.98907 29.6366 3.79707 29.6366 4.63958V7.81627M0.852539 7.81627H29.6366M7.249 14.1697H15.2446",
    stroke: "#333333",
    strokeWidth: 1.68891,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit_card.993108df7317931544c2b8d539c21428.svg";
export { ForwardRef as ReactComponent };